<template>
  <button
    :id="target + 'Btn'"
    class="lightbox__button"
    :for="target"
    @click="
      setDatastoreValue(),
      $root.lightboxButtonClick(
        $event,
        target,
        prefix,
        optimizelyPrefix,
        optimizelyPostfix
      ),
        youtubeLoad(target, youtubeId),
        setResourceCookie(),
        setPricingPlanCookie(pricingPlan)
    "
  >
    <div>
      <slot></slot>
    </div>
  </button>
</template>

<script>
import Vue from 'vue';
import cookie from 'js-cookie';
import VueYoutube from '../../mixins/vue-youtube';
import selfCheckout from '../form/onboarding/self-checkout';
import { getGlobalDatastoreValue } from '../../../helpers/global-datastore';

export default {
  mixins: [VueYoutube],
  props: [
    'optimizelyPrefix',
    'optimizelyPostfix',
    'target',
    'youtubeId',
    'prefix',
    'resource',
    'pricingPlan',
    'datastoreKey',
    'rootDatastoreKey'
  ],
  methods: {
    setDatastoreValue(){
      if(!this.datastoreKey) return;
      Vue.set(this.$root.datastore, this.rootDatastoreKey, getGlobalDatastoreValue(this.datastoreKey));
    },
    setResourceCookie() {
      if (!this.resource) return;
      cookie.set('_sk_resource', this.resource);
    },
    setPricingPlanCookie() {
      // we are setting the value even if it is blank, since
      // if we open a non-plan specific lightbox we want this to be blank
      selfCheckout.setPricingPlan(this.pricingPlan);
    },
  },
};
</script>
